import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import OptimizeImagesService from 'services/OptimizeImages.service';
import LanguageService from 'services/Language.service';
import { ANCHOR } from 'common/consts/common';
import styles from './ArticleHeader.module.scss';
import ConditionalLink from 'common/components/ConditionalLink/ConditionalLink';
import moment from 'moment';

@injectIntl
export default class ArticleHeaderComponent extends Component {
  static propTypes = {
    news: PropTypes.object
  };

  currentLanguage = LanguageService.getLang();

  render() {
    const { className, isLink, news } = this.props;
    return (
      <div className={`${styles.ArticleHeader} ${className}`}>
        <ConditionalLink
          condition={isLink}
          to={`${ANCHOR.NEWS[this.currentLanguage]}/${news.category}/${
            news.slug
          }`}
        >
          <div
            className={styles.ArticleHeaderImage}
            style={{
              backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                news.photo
              )})`
            }}
          />
        </ConditionalLink>
        <div className={styles.ArticleHeaderBox}>
          <ConditionalLink
            condition={isLink}
            to={`${ANCHOR.NEWS[this.currentLanguage]}/${news.category}/${
              news.slug
            }`}
            className={styles.ArticleHeaderTitle}
          >
            <h2 className={styles.ArticleHeaderTitle}>{news.title}</h2>
          </ConditionalLink>

          <div className={styles.ArticleHeaderDate}>
            {moment(news.publicationDate).format('LL')}
          </div>
          <div>
            {news.companies.map(company => (
              <img
                key={company.id}
                src={OptimizeImagesService.adjustImageSize(company.logo)}
                alt={company.name}
                className={styles.ArticleHeaderCompanyLogo}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/News/components/Article/ArticleHeader/ArticleHeader.js